module.exports = "/layout/app/images/bg-header-lg.605a9671.svg";